import { Component, ReactNode } from 'react';

type Props = {
  defaultValue?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (arg0: boolean, arg1: (...args: Array<any>) => any) => ReactNode;
};
type State = {
  toggled: boolean;
};

export class ToggleHelperContainer extends Component<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    defaultValue: false,
  };

  // TODO: Fix this the next time the file is edited.
  // @ts-expect-error TS(2416): Property 'state' in type 'ToggleHelperContainer' i... Remove this comment to see the full error message
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    toggled: this.props.defaultValue,
  };

  render() {
    // @ts-expect-error TS(2345): Argument of type 'boolean | undefined' is not assi... Remove this comment to see the full error message
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children(this.state.toggled, (setToggle) =>
      this.setState((prevState) => {
        const toggled =
          typeof setToggle === 'boolean' ? setToggle : !prevState.toggled;
        return {
          toggled,
        };
      }),
    );
  }
}
